import { PersistentStore } from './Store';
import { Database } from '.';

interface FileSystemState {
  rootHandle: FileSystemDirectoryHandle;
}

export default class FileSystemStore extends PersistentStore<FileSystemState> {
  protected data(): FileSystemState {
    return {
      rootHandle: null
    };
  }

  static Upgrade(db: Database, oldVersion: number, newVersion: number): void {
    if (newVersion === 1) {
      db.createObjectStore('handles');
    }
  }

  async initialize(): Promise<void> {
    // Try and reinitialize an existing handle
    const root = await this.db.get('handles', 'root') as FileSystemDirectoryHandle;
    if (root && !root.isDirectory) {
      throw new Error('Root FileSystemHandle is not a directory');
    }

    if (root && await root.requestPermission({ writable: true }) === 'granted') {
      // User granted permission to use existing handle
      console.log('Granted permission');
      this.state.rootHandle = root;
    } else {
      // Prompt user to select a new handle and save to database
      this.state.rootHandle = await window.chooseFileSystemEntries({ type: 'open-directory' });
      await this.db.put('handles', this.state.rootHandle, 'root');
    }
  }

  async resolveFile(path: string[]): Promise<File> {
    // TODO First element should pick what root we use
    path = path.slice();
    path.shift();

    const fileName = path.pop();
    let at = this.state.rootHandle;
    for (const el of path) {
      at = await at.getDirectory(el);
    }
    const file = await at.getFile(fileName);
    return await file.getFile();
  }

  async setupMetaDirectory(): Promise<FileSystemDirectoryHandle> {
    const root = this.state.rootHandle;
    const ca = await root.getDirectory('__civilian_applications', { create: true });
    const artwork = await ca.getDirectory('artwork_cache', { create: true });
    return artwork;
  }

  async fileExists(directory: FileSystemDirectoryHandle, filename: string, allowEmpty = false): Promise<boolean> {
    try {
      const handle = await directory.getFile(filename);
      const file = await handle.getFile();
      return allowEmpty || file.size > 0;
    } catch (e) {
      return false;
    }
  }
}
